import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showUpdateProviderConfigForm: false,
  showCancelUpdateProviderConfigForm: false,
  showDeleteProviderConfigForm: false,
  selectedProviderConfig: {},
};

const updateProviderConfigSlice = createSlice({
  name: 'updateProviderConfig',
  initialState,
  reducers: {
    setShowUpdateProviderConfigForm: (state, { payload }) => {
      state.showUpdateProviderConfigForm = payload;
    },
    setShowCancelUpdateProviderConfigForm: (state, { payload }) => {
      state.showCancelUpdateProviderConfigForm = payload;
    },
    setSelectedProviderConfig: (state, { payload }) => {
      state.selectedProviderConfig = payload;
    },
    setShowDeleteProviderConfigForm: (state, { payload }) => {
      state.showDeleteProviderConfigForm = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: updateProviderConfigReducer } = updateProviderConfigSlice;
export const {
  setShowUpdateProviderConfigForm,
  setShowCancelUpdateProviderConfigForm,
  setSelectedProviderConfig,
  setShowDeleteProviderConfigForm,
} = updateProviderConfigSlice.actions;
